import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import PassengerSelectionWeb from "./layouts/PassengerSelection.web";
import PassengerSelectionMob from "./layouts/PassengerSelection.mob";



const PassengerSelectionComponent = withConditionalComponent(PassengerSelectionWeb,PassengerSelectionMob)

export default function PassengerSelection() {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <PassengerSelectionComponent trigger={isLargeScreen}/>
}
